import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    const targetDate = new Date().getTime() + 15 * 60 * 1000;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        clearInterval(interval);
        setTimeLeft({
          minutes: 0,
          seconds: 0
        });
        return;
      }
      setTimeLeft({
        minutes: Math.floor(distance / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="w-full bg-soft-brown py-3 sticky top-0 z-50 pl-[10px] pr-[10px]" data-id="element-12">
      <div className="max-w-5xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 pl-[16px] pr-[16px]" data-id="element-13">
        <p className="text-creme font-bold text-xs sm:text-sm tracking-widest uppercase opacity-90" data-id="element-14">
          ESTA OFERTA DESAPARECE EN:
        </p>
        <div className="flex items-center gap-1 text-white font-playfair font-bold text-xl sm:text-2xl" data-id="element-15">
          <span className="text-[24px]" data-id="element-16">{formatNumber(timeLeft.minutes)}</span>
          <span className="animate-pulse text-warm-accent" data-id="element-17">:</span>
          <span className="text-[24px]" data-id="element-18">{formatNumber(timeLeft.seconds)}</span>
        </div>
      </div>
    </div>;
}